<ng-container *ngIf="loaded">
    <ng-container *ngIf="fieldList">
        <angular2-smart-table [settings]="settings" [source]="source" (edit)="editRow($event)" (delete)="deleteRow($event)"></angular2-smart-table>
    </ng-container>
</ng-container>
